import * as Typed from "../TintPicker.typed";

export const paintCanvas = (
  canvas: HTMLCanvasElement,
  colorInfo: Typed.ColorInfo | null,
  rgbString: string | null,
  imageUrl: string
) => {
  const img = new Image();

  img.onload = async () => {
    const offsetX = img.width - window.screen.width;

    if (window.screen.width < img.width) {
      canvas.width = img.width - offsetX;
    } else {
      canvas.width = img.width;
    }

    canvas.height = img.height + 130;

    const ctx = canvas.getContext("2d");

    if (ctx === null) return;

    ctx.fillStyle = rgbString ? `rgb(${rgbString})` : "#ffffff";

    ctx.fillRect(0, 0, img.width, img.height + 137);

    const centeredText = offsetX < 0 ? 0 : -offsetX;

    ctx.drawImage(img, centeredText, 0, img.width, img.height);

    if (!colorInfo) return;

    ctx.font = "bold 24px Roboto";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = colorInfo.isPrimaryLight ? "#000" : "#FAFAFA";
    ctx.fillText(colorInfo.code, canvas.width / 2, img.height + 67);
  };

  img.src = imageUrl;
};
